import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal, Table } from 'antd';
import { RootState } from '../../../store';
import { TIMELINE_RECONCILIATION_DETAIL_TABLE_COLUMNS_TITLE } from '../../constants/reconciliationConstants';
import '../../../modules/reconciliation/reconciliation.less';
const ReconciliationTimelineDetailModal = ({ match, isTimelineDetailModal, handleCancel }: any): any => {
  const {reconciliationAuditTrail} = useSelector((state: RootState): any => state?.reconciliation);
  const [flowList, setFlowList] = useState([] as any);

  useEffect((): any => {
    if (reconciliationAuditTrail) {
      const localArr: any[] = reconciliationAuditTrail.map(({
        claimStatus: title, submittedBy: submittedBy, claimedApprovedAmount: approvedAmount, utrNumber: utrNo,
        utrSetteledDate: utrSettledDate, utrSetteledAmount: settled, tdsAmount: tds, doa: doa, dod: dod,
        reconciliationComments,
      }: any, index: any): any => ({
        title, submittedBy, utrNo, utrSettledDate, approvedAmount, settled, tds, doa, dod, reconciliationComments,
      }));
      setFlowList(localArr);
    }
  }, [reconciliationAuditTrail]);

  return (
    <div>
      <Modal
        visible={isTimelineDetailModal}
        onCancel={handleCancel}
        maskClosable={false}
        closable={true}
        width={1100}
        footer={null}
      >
        <Table className="reconTable" dataSource={flowList} pagination={false} title={(): any => ' '}
          size={'small'} columns={TIMELINE_RECONCILIATION_DETAIL_TABLE_COLUMNS_TITLE} scroll={{ x: 300, y: 400 }} />
      </Modal>
    </div>
  );
};

export default withRouter(ReconciliationTimelineDetailModal);
